import { Caption } from './cms-data';

export class Utils {

    static timecodeToSeconds(input: string): number {
        let value: number = 0;
        const temp: string[] = input.split(':').reverse();
        for (let i = temp.length - 1; i >= 0; i--) {
            value += Number(+temp[i] * Math.pow(60, i));
        }
        return value;
    }

    static splitStringForDoubleCurlies(str: string): string[] {
        const strArray: string[] = [];
        const pattern = /\{{(.*?)\}}/g;
        let match: any = pattern.exec(str);
        while (match != null) {
            strArray.push(match[1]);
            match = pattern.exec(str);
        }
        return strArray;
    }
    static secondsToTimecode(input: number): string {
        if (input) {
            const hours: number = Math.floor(input / 3600);
            const minutes: number = Math.floor((input - (hours * 3600)) / 60);
            const seconds: number = Math.floor(input - (hours * 3600) - (minutes * 60));
            const hoursStr: string = hours < 10 ? '0' + hours : hours.toString();
            const minutesStr: string = minutes < 10 ? '0' + minutes : minutes.toString();
            const secondsStr: string = seconds < 10 ? '0' + seconds : seconds.toString();
            return hoursStr + ':' + minutesStr + ':' + secondsStr;
        } else {
            return '00:00:00';
        }
    }
    static prependProtocol(input: any) {
        // if(!((window !== undefined || document !== undefined))){
        //     return '';
        // }
        // else {
        //     const protocol = window.location.protocol === 'file:' ? 'https:' : window.location.protocol;
        //     return protocol + input.replace(/^https?:/i, '');
        // }
        return 'https:' + input.replace(/^https?:/i, '');
    }

    // static SSRSafeFunction(){
    //     try {
    //         return !((window !== undefined && document !== undefined))
    //       } catch(e) {
    //           console.log("e in catch", e);
    //         return true;
    //       }
    // }

    static getStreamingSource(source: any, extension?: string): any {
        extension = extension ? '.' + extension.toLowerCase() : '';
        if (source && source.endsWith('_480')) {
            source = source.substring(0, source.length - 4);
        }
        return source + extension;
    }

    static groupCaptions(captions: Caption[]) {
        const result: Caption[] = [];
        const captionsLength: number = captions.length;
        let fragment: Caption = {
            begin: 0,
            end: 0,
            text: '',
        };
        for (let i: number = 0; i < captionsLength; i++) {
            const caption = captions[i];
            if (caption.text.charAt(0) === caption.text.charAt(0).toUpperCase()) {
                if (fragment.text.length) {
                    result.push(fragment);
                }
                fragment = {
                    begin: caption.begin,
                    end: 0,
                    text: '',
                };
            }
            if (caption.text.charAt(caption.text.length - 1) !== '.') {
                fragment.text += (fragment.text.length ? ' ' : '') + caption.text;
                if (fragment.begin === 0) {
                    fragment.begin = caption.begin;
                }
                fragment.end = caption.end;
                continue;
            }
            fragment.text += (fragment.text.length ? ' ' : '') + caption.text;
            fragment.begin = fragment.text.length ? fragment.begin : caption.begin;
            fragment.end = caption.end;
            result.push(fragment);
            fragment = { text: '', begin: caption.begin, end: 0 };
        }
        return result;
    }

    static getBreakPoint() {
        let breakPoint = 1366;
        if (navigator.userAgent !== null && navigator.userAgent !== undefined) {
            if (navigator.userAgent.match(/Tablet|iPad/i)) {
                breakPoint = 1024;
            } else if (navigator.userAgent.match(/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|Blackberry/i)) {
                breakPoint = 767;
            }
        }
        return breakPoint;
    }
}

export function ssrSafe<T>(
    func: () => T,
    dependencies: any[] = [
        (typeof process === "object" && (process as any).browser) || typeof window === "object",
    ],
  ) {
    // ensures browser specific functions are run only if browser is available whether in ssr or client
    if (dependencies.every(Boolean)) {
        return func();
    }
  
    return undefined;
  }
  
  export function makeSsrSafe<T extends CallableFunction>(func: T, dependencies?: any[]): T {
    return (function(this: ThisParameterType<T>, ...args: any[]) {
        return ssrSafe(() => {
            return (func as any).call(this, ...args);
        }, dependencies);
    } as any) as T;
  }
  
  
  export const isIos = makeSsrSafe(() => {
    return Boolean(navigator.userAgent && /ipad|iphone|ipod/i.test(navigator.userAgent));
  });


// The functional component is meant to call AEM feed for the page.

// const fetch = (url, options) => {
//     return new Promise((resolve, reject) => {
//         omniFetch(url, options).then(
//             response => {
//                 resolve(response);
//             },
//             err => reject(err)
//         );
//     });
// };

// This fucntion is used by the applications to call their respective CMS feed(Page feed)
// pageURL:             The url for the page they need for the application.
// DB Type:             And the type of DB they are using to fetch the feed.
// applicationHeaders:  If there is a need to add the custom headers.
//import cmsReaderSanity from '@idp/bit.dev/cmsreaderSanity'

 export const CMSReaderAem = async (pageURLorStubDataObject: any, pageObjectName:any, usingStub?: boolean, applicationHeaders?: any) => {
    let options = {};
    let readerResponse:any ={};
    const isUsingStub: boolean = usingStub;

    //Used for adding common headers throughout IDP
    // applicationHeaders ::: Gives the ability to the application teams to add their own headers.
    //const customHeaders: any = {'Content-Type': 'application/json'}; //  need to add default headers // TODO
    options = {
        //headers: applicationHeaders? applicationHeaders : '',
        timeout: 5000,
    };
        if(!isUsingStub) { 
            readerResponse = await fetch( pageURLorStubDataObject , options as RequestInit)
                .then((response: any) => {
                    if (response.status >= 400) {
                        throw new Error(`Bad response from server: ${response.status}`);
                    }   
                    console.info(`fetch successful`);
                    return response;
                }).then((response) => response ? response.json() : null)
                .then((resp) => resp)
                .catch(function (err) {console.info(` fetch fail ${err}`);
                    return Promise.reject(err); 
                });
            } else {
                readerResponse = pageURLorStubDataObject;
            }
            //console.log("RESPONSE::::::::", readerResponse)
            //let processedResponse = {};
            if( (!isUsingStub  && pageURLorStubDataObject.includes('idpcms')) || isUsingStub && pageURLorStubDataObject['idp-cms-feed']) {
                readerResponse = removeMasterObject(readerResponse); // only needed for 6.4 AEM feed
                readerResponse = feedObjectCorrectorAEM6dot4(readerResponse, 'AEM6dot4', pageObjectName);
            } else if( (!isUsingStub  && pageURLorStubDataObject.includes('dtvcms')) || (isUsingStub  && pageURLorStubDataObject[':items'])) {
                readerResponse = feedObjectCorrectorAEM6dot5(readerResponse, 'AEM6dot5');
            }

        return readerResponse;
    }


export const feedObjectCorrectorAEM6dot4 = (feedResp: any, typeOfDB?: string, pageName?:any) => {
    if (feedResp && pageName && feedResp['idp-cms-feed']) {
        let feedObject: any = feedResp['idp-cms-feed']?.[pageName];
        for(var addedObject in feedObject){
            if (feedObject.contentFragments.pageProperties) {
                feedObject.contentFragments.pageProperties[addedObject] = feedObject[addedObject]
                feedObject.contentFragments.pageProperties["dBType"] = typeOfDB;
                delete feedObject.contentFragments.pageProperties.contentFragments;
            } else { 
                feedObject.contentFragments[addedObject] = feedObject[addedObject];
                feedObject.contentFragments["dBType"] = typeOfDB;
                delete feedObject.contentFragments.contentFragments;
            }      
        }
        feedObject = feedObject.contentFragments;
        //console.log("Feed Object outer object added to pageprops 6.4 :::",feedObject )
        return feedObject;
    }
};


export const feedObjectCorrectorAEM6dot5 = (feedResp: any, typeOfDB?: string) => {
    if (feedResp && feedResp[':items'] && feedResp['index'])  {
        let feedObject: any = feedResp;
        feedObject[":items"] = {...feedObject[":items"], ...feedObject['index']}    
        // delete feedObject['index'];
        feedObject[":items"]['dBType'] = typeOfDB;
        //console.log("Feed Object outer object added to pageprops 6.5 :::",feedObject[":items"] )
        return feedObject[":items"];
    }
};

export const removeMasterObject = (jsonobj: any) => {

    let obj: any = jsonobj;
    if ( typeof obj !== 'boolean'
        && typeof obj !== 'number' && typeof obj !== 'string' 
        && typeof Object.keys(obj) !== 'undefined' && Object.keys(obj).length > 0) {
        const keys = Object.keys(obj);
        keys.map((key, val) => {
            if (obj[key] && obj[key].master) {
                Object.assign(obj[key], obj[key].master);
                delete obj[key].master;
                removeMasterObject(obj[key]);
            } else {
                if (typeof obj[key] !== 'string') {
                    // /console.log(typeof obj[key]);
                    removeMasterObject(obj[key]);
                }
            }
        });
    }
    return obj;
}
